import React from 'react';
import PropTypes from 'prop-types';
import ActionsMenu from 'src/components/ActionsMenu';
import TextButton from 'src/components/TextButton';
import {
  VariationsContainer,
  VariationsWrapper,
  VariationsHeader,
  VariationTitle,
  ListStyled,
  ListItem
} from './style';

const VariationList = ({
  variations,
  activeVariationId,
  handleSelectVariation,
  handleAddNewVariation,
  handleDeleteVariation,
  handleDuplicateVariation
}) => {
  const actions = row => [
    { title: 'Duplicate', action: () => handleDuplicateVariation(row) },
    { title: 'Delete', action: () => handleDeleteVariation(row) }
  ];

  return (
    <VariationsContainer>
      <VariationsWrapper>
        <VariationsHeader>
          <VariationTitle>Variations</VariationTitle>
          <TextButton onClick={handleAddNewVariation} size="small">
            + Add
          </TextButton>
        </VariationsHeader>
        <ListStyled>
          {variations.map((item, idx) => (
            <ListItem
              // eslint-disable-next-line react/no-array-index-key
              key={idx}
              active={item.id === activeVariationId}
              onClick={() => handleSelectVariation(idx)}
            >
              {item.name || 'untitled'}
              <ActionsMenu row={item} actions={actions} />
            </ListItem>
          ))}
        </ListStyled>
      </VariationsWrapper>
    </VariationsContainer>
  );
};

VariationList.propTypes = {
  variations: PropTypes.arrayOf(PropTypes.any).isRequired,
  handleSelectVariation: PropTypes.func.isRequired,
  handleDuplicateVariation: PropTypes.func.isRequired,
  handleDeleteVariation: PropTypes.func.isRequired,
  handleAddNewVariation: PropTypes.func.isRequired,
  activeVariationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default VariationList;
